import { DynamicFormGroupModel } from '@ng-dynamic-forms/core';

export class DynamicRowGroupModel extends DynamicFormGroupModel {
  isRowGroup = true;
}
